export const Types = {
  SAVE_LIST_CATEGORY: 'SAVE_LIST_CATEGORY',
  SAVE_LIST_BLOG: 'SAVE_LIST_BLOG',
  SAVE_LIST_TAG: 'SAVE_LIST_TAG',
  SAVE_ALL_TAG: 'SAVE_ALL_TAG',
  SAVE_LIST_BLOG_CATEGORY: 'SAVE_LIST_BLOG_CATEGORY'
}